<script setup lang="ts">
const props = defineProps({
  tag: { type: String, default: 'div' },
});
</script>

<template>
  <component
    :is="props.tag"
    class="title"
  >
    <slot />
  </component>
</template>

<style scoped lang="scss">
.title {
  @apply text-titles font-semibold mr-2 md:mr-4 text-sm sm:text-base lg:text-lg leading-5;

  @media print {
    color: #2f2d2e !important;
  }
}
</style>
